import { CandidateJobMatchCardComponent } from "./candidate-job-match-card.component";
export var CandidateJobMatchCardModule = angular
    .module('candidateJobMatchCard', [])
    .component(CandidateJobMatchCardComponent.selector, CandidateJobMatchCardComponent.component)
    .name;
//# sourceMappingURL=candidate-job-match-card.module.js.map